/*
 * Curated Covey — scroll reveal.
 * Tags content blocks below the hero, then fades/rises them in as they enter
 * the viewport, staggering items that arrive together (e.g. a row of cards).
 * The <html class="cc-motion"> gate is set inline in <head> (snippets/cc-motion.liquid).
 */
(() => {
  const root = document.documentElement;
  if (!root.classList.contains('cc-motion') || !('IntersectionObserver' in window)) return;
  window.ccReveal = true;

  const SCOPES = [
    // The hero, main product section (gallery + buy box) and cart are never hidden.
    "#MainContent > .shopify-section:not([id$='__cc_hero']):not([id$='__main']):not([id$='__cart-section'])",
    '.shopify-section-group-footer-group',
  ].join(',');

  // Outermost match wins: once a card is tagged, its title/price/button ride along with it.
  const ITEMS = [
    '[data-cc-item]',
    '.resource-list__item',
    '.product-grid__card',
    '.resource-card',
    '.group-block__media-wrapper',
    '.text-block',
    '.button',
    '.button-secondary',
    'form',
    'nav',
    'ul',
    'img',
    'svg.placeholder-svg',
  ].join(',');

  const STAGGER_MS = 80;
  const MAX_STAGGER_STEPS = 8;
  const SETTLE_MS = 1400;

  const observer = new IntersectionObserver(
    (entries) => {
      const arriving = entries
        .filter((entry) => entry.isIntersecting)
        .sort(
          (a, b) =>
            a.boundingClientRect.top - b.boundingClientRect.top ||
            a.boundingClientRect.left - b.boundingClientRect.left
        );

      arriving.forEach((entry, index) => {
        const el = entry.target;
        const delay = Math.min(index, MAX_STAGGER_STEPS) * STAGGER_MS;
        observer.unobserve(el);
        el.style.setProperty('--cc-delay', `${delay}ms`);
        el.dataset.ccReveal = 'in';
        // Drop the reveal styles once settled so hover effects and transforms behave normally.
        setTimeout(() => {
          el.dataset.ccReveal = 'done';
          el.style.removeProperty('--cc-delay');
        }, delay + SETTLE_MS);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0 }
  );

  const prepare = (scope) => {
    for (const el of scope.querySelectorAll(ITEMS)) {
      if (el.parentElement.closest('[data-cc-reveal]')) continue;
      if (el.closest('dialog, [hidden], .visually-hidden')) continue;
      if (el.tagName !== 'IMG' && !el.children.length && !el.textContent.trim()) continue;
      el.dataset.ccReveal = '';
      observer.observe(el);
    }
    scope.dataset.ccReady = '';
  };

  const init = () => document.querySelectorAll(SCOPES).forEach(prepare);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
